export type SampleKey = "json" | "csv" | "yaml";

export const samples: Record<SampleKey, string> = {
  json: `[
  {
    "id": 1001,
    "user": { "name": "Alice Kim", "email": "alice.kim@example.com", "role": "analyst" },
    "active": true,
    "score": 98.7,
    "tags": ["data", "quality", "core"],
    "created_at": "2026-05-01T09:15:30Z"
  },
  {
    "id": 1002,
    "user": { "name": "Bob Lee", "email": "bob.lee@example.com", "role": "engineer" },
    "active": true,
    "score": 87.2,
    "tags": ["etl", "backend"],
    "created_at": "2026-05-01T10:20:00Z"
  },
  {
    "id": 1003,
    "user": { "name": "Carol Park", "email": "", "role": "analyst" },
    "active": false,
    "score": "needs review",
    "tags": ["data", "viz"],
    "created_at": "2026-05-01T11:02:10Z"
  },
  {
    "id": 1004,
    "user": { "name": "David Choi", "email": "david.choi@example.com", "role": "manager" },
    "active": true,
    "score": 78.1,
    "tags": ["ops", "review"],
    "created_at": "2026-05-01T12:44:18Z"
  },
  {
    "id": 1005,
    "user": { "name": "Eun Seo", "email": "eun.seo@example.com", "role": "analyst" },
    "active": true,
    "score": 91.4,
    "tags": ["warehouse", "quality"],
    "created_at": "2026-05-01T13:05:40Z"
  },
  {
    "id": 1006,
    "user": { "name": "Felix Grant", "email": "felix.grant@example.com", "role": "engineer" },
    "active": true,
    "score": 84.6,
    "tags": ["api", "backend"],
    "created_at": "2026-05-01T13:28:22Z"
  },
  {
    "id": 1007,
    "user": { "name": "Grace Han", "email": "grace.han@example.com", "role": "designer" },
    "active": false,
    "score": 73.2,
    "tags": ["research", "handoff"],
    "created_at": "2026-05-01T14:10:04Z"
  },
  {
    "id": 1008,
    "user": { "name": "Hugo Martin", "email": "hugo.martin@example.com", "role": "analyst" },
    "active": true,
    "score": 89.9,
    "tags": ["billing", "checks"],
    "created_at": "2026-05-01T15:19:51Z"
  },
  {
    "id": 1009,
    "user": { "name": "Iris Moon", "email": "iris.moon@example.com", "role": "support" },
    "active": true,
    "score": 82.4,
    "tags": ["crm", "export"],
    "created_at": "2026-05-01T16:45:05Z"
  },
  {
    "id": 1010,
    "user": { "name": "Joon Park", "email": "joon.park@example.com", "role": "engineer" },
    "active": true,
    "score": 95.1,
    "tags": ["release", "core"],
    "created_at": "2026-05-01T17:08:27Z"
  }
]`,
  csv: `id,name,email,role,active,score,region
1001,Alice Kim,alice.kim@example.com,analyst,true,98.7,KR
1002,Bob Lee,bob.lee@example.com,engineer,true,87.2,US
1003,Carol Park,,analyst,false,needs review,KR
1004,David Choi,david.choi@example.com,manager,true,78.1,SG
1005,Eun Seo,eun.seo@example.com,analyst,true,91.4,KR
1006,Felix Grant,felix.grant@example.com,engineer,true,84.6,US
1007,Grace Han,grace.han@example.com,designer,false,73.2,SG
1008,Hugo Martin,hugo.martin@example.com,analyst,true,89.9,DE
1009,Iris Moon,iris.moon@example.com,support,true,82.4,KR
1010,Joon Park,joon.park@example.com,engineer,true,95.1,US`,
  yaml: `dataset: webhook_audit
owner:
  name: Eun Jung
  team: data-quality
records:
  - id: evt_1001
    status: delivered
    latency_ms: 142
    retry: false
  - id: evt_1002
    status: delayed
    latency_ms: 984
    retry: true
checks:
  schema: inferred
  local_only: true`
};
